import * as types from '../../../../../../lib/actionTypes.es6'


export function getNGSGroupCustomerClaimsRequest(customerGuid){
  return{
    type: types.GET_NGSGROUP_CUSTOMER_CLAIMS_REQUEST,
    payload: customerGuid
  }
}


export const getNGSGroupCustomerClaimsSuccess = (payload) =>{
  return{
    type: types.GET_NGSGROUP_CUSTOMER_CLAIMS_SUCCESS,
    payload: payload,
  }
}

export const getNGSGroupCustomerClaimsFailure = (error) =>{
  return{
    type: types.GET_NGSGROUP_CUSTOMER_CLAIMS_FAILURE,
    payload: error,
  }
}